<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let icon: { [key: string]: string };
  export let tooltip: string;
  export let showTip: boolean;
  export let tooltipClasses: string = "";
</script>

<span class="fizz-tooltip-container">
  <div class="fizz-tooltip-trigger" aria-describedby="popover-tooltip">
    {#if icon.class}
      <Icon className={icon.class} type={icon.type} />
    {:else}
      <Icon width={icon.width} height={icon.height} type={icon.type} />
    {/if}
  </div>
  {#if showTip}
    <div
      class="fizz-tooltip fizz-tooltip-top fizz-tooltip-center {tooltipClasses}"
      role="tooltip"
      id="popover-tooltip"
    >
      {tooltip}
    </div>
  {/if}
</span>
